<template>
  <div>
    <div class="table">
      <div v-if="!server">
        <v-checkbox
          v-if="page_type === 'base_main' || page_type === 'calls'"
          class="new"
          v-model="selectAll"
          @change="selectAllItems"
          label="Выбрать все"
          color="#4B5EFF"
        ></v-checkbox>
        <v-data-table
          v-model="selected"
          @input="enterSelect()"
          :mobile-breakpoint="
            page_type === 'carousels' || page_type === 'all_numbers'
              ? 1024
              : 600
          "
          locale="ru-RU"
          checkbox-color="#4B5EFF"
          :loading="loading"
          :page.sync="page"
          :custom-sort="customSort"
          :headers="displayHeaders"
          :show-select="!hideselect"
          :items="displayData"
          :itemsPerPage="perPage"
          @page-count="pageCount = $event"
          hide-default-footer
          :no-data-text="noDataText || 'Нет записей'"
          item-key="id"
          item-disabled="selectDisabled"
          :item-class="carouselRowClass"
          :class="[
            'elevation-1',
            {
              'carousel-fixed-table': page_type === 'carousels',
              'numbers-mobile-table':
                page_type === 'carousels' || page_type === 'all_numbers',
              'all-numbers-compact-table': page_type === 'all_numbers',
            },
          ]"
          loading-text="Загружаем данные таблицы"
        >
          <template v-slot:progress>
            <v-progress-linear indeterminate color="#4B5EFF" absolute top />
          </template>
          <template v-slot:[`item.created_at`]="{ item }">
            <p v-if="page_type === 'get_service_table'">
              {{ item.created_at }}
            </p>
            <p v-else>{{ getDateFormat(item.created_at) }}</p>
          </template>
          <template v-slot:[`item.status`]="{ item }">
            <div class="status_wait" v-if="item.status == 'wait'">
              в процессе
            </div>
            <div class="status_end" v-if="item.status == '1'">завершен</div>
            <div class="status_stop" v-if="item.status == 'stop'">
              остановлен
            </div>
            <div class="status_uncall" v-if="item.status == '-1'">недозвон</div>
            <div class="status_success" v-if="item.status == 'success'">
              Успешно
            </div>
            <div class="status_wait" v-if="item.status == 'waiting'">
              Ждет проверки
            </div>
            <div class="status_stop" v-if="item.status == 'cancelled'">
              Отказано
            </div>
            <div class="status_stop" v-if="item.status == 'failed'">
              Неуспешно
            </div>
            <div
              v-if="item.status == 'created' || item.status == 'queued'"
              class="status_wait"
            >
              В обработке
            </div>
          </template>

          <template v-slot:[`item.user_status`]="{ item }">
            <div class="status_wait" v-if="item.user_status == 'waiting'">
              Ждет проверки
            </div>
            <div class="status_success" v-if="item.user_status == 'active'">
              Активен
            </div>
            <div class="status_stop" v-if="item.user_status == 'unactive'">
              Не активен
            </div>
          </template>

          <template v-slot:[`item.phoneNumber`]="{ item }">
            <strong
              v-if="page_type === 'all_numbers'"
              class="all-numbers-phone"
            >
              {{ item.phoneNumber || '—' }}
            </strong>

            <span v-else>{{ item.phoneNumber || '—' }}</span>
          </template>

          <template v-slot:[`item.numberStatus`]="{ item }">
            <div v-if="page_type === 'all_numbers'" class="number-status">
              <span
                class="number-status__dot"
                :class="{
                  'number-status__dot--active': item.numberStatus === 'Активен',
                  'number-status__dot--incoming':
                    item.numberStatus === 'Только входящие',
                }"
              />

              <span>{{ item.numberStatus || '—' }}</span>
            </div>

            <span v-else>{{ item.numberStatus || '—' }}</span>
          </template>

          <template v-slot:[`item.operator`]="{ item }">
            <span>{{ item.operator || '—' }}</span>
          </template>

          <template v-slot:[`item.status_pay`]="{ item }">
            <div class="status_wait" v-if="item.status_pay == 'waiting'">
              Ждет проверки
            </div>
            <div class="status_success" v-if="item.status_pay == 'success'">
              Успешно
            </div>
            <div class="status_stop" v-if="item.status_pay == 'cancelled'">
              Отказано
            </div>
          </template>

          <template v-slot:[`item.Pcosent_Convesion_Target`]="{ item }">
            <div>{{ item.Pcosent_Convesion_Target }} %</div>
          </template>
          <template v-slot:[`item.Pcosent_Convesion_Target1`]="{ item }">
            <div>{{ item.Pcosent_Convesion_Target1 }} %</div>
          </template>
          <template v-slot:[`header.Convesion_Target`]="{ header }">
            <v-tooltip top max-width="300" color="#2B2D33">
              <template v-slot:activator="{ on, attrs }">
                <span v-bind="attrs" v-on="on">
                  <div class="forIc">
                    <Icon class="ic" name="question" />
                  </div>
                </span>
              </template>
              Успешным считается звонок, достигший любой цели в ходе сценария
            </v-tooltip>
            {{ header.text }}
          </template>

          <template v-slot:[`header.Pcosent_Convesion_Target`]="{ header }">
            <v-tooltip top max-width="300" color="#2B2D33">
              <template v-slot:activator="{ on, attrs }">
                <span v-bind="attrs" v-on="on">
                  <div class="forIc">
                    <Icon class="ic" name="question" />
                  </div>
                </span>
              </template>
              Успешным считается звонок, достигший любой цели в ходе сценария
            </v-tooltip>
            {{ header.text }}
          </template>
          <!-- ШЕСТЕРЁНКА РАСПОЛОЖЕНИЕ -->
          <template #[`header.group_actions`]>
            <v-btn
              icon
              x-small
              @click="groupByDialog = true"
              title="Группировка"
            >
              <v-icon x-big>mdi-cog</v-icon>
            </v-btn>
          </template>

          <template v-slot:[`item.target_limit`]="{ item }">
            <div class="target_container" v-if="item.target_on">
              <div class="target_des">{{ item.target }}/{{ item.limit }}</div>
              <div
                @click="$emit('clearTarget', item)"
                v-if="item.target_rate > 0"
                class="target"
              >
                <Icon name="delete" />
              </div>
            </div>
            <div v-else>---</div>
          </template>

          <template v-slot:[`item.target_price`]="{ item }">
            <div
              class="target_container"
              v-if="item.target_on && item.target > 0"
            >
              <div class="target_des">
                {{ (item.target_rate / item.target).toFixed(2) }} р.
              </div>
            </div>
            <div v-else>---</div>
          </template>

          <template v-slot:[`item.nums`]="{ item }">
            <div>{{ item.contacts }}/{{ item.call }}</div>
          </template>

          <template v-slot:[`item.url`]="{ item }">
            <div>
              https://gate.{{ $baseDomain }}/api/web/u{{
                $store.getters['user/getName'].replace(/[^0-9]/g, '')
              }}/{{ item.guid }}
            </div>
          </template>

          <template v-slot:[`item.unique`]="{ item }">
            <span v-if="!item.unique">Отключено</span>
            <span v-else-if="item.uniqtype === 'uploaded'"
              >Внутри загружаемых</span
            >
            <span v-else-if="item.uniqtype === 'database'">По всей базе</span>
            <span v-else-if="item.uniqtype === 'all'">По всем моим базам</span>
            <span v-else>Включено</span>
          </template>

          <template v-slot:[`item.date`]="{ item }">
            <div class="table_text">{{ getDateFormat(item.date) }}</div>
          </template>
          <template v-slot:[`item.sum`]="{ item }">
            <div class="table_text" :class="numClass(item.sum)">
              {{ item.sum }}
            </div>
          </template>
          <template v-slot:[`item.phone`]="{ item }">
            <div class="table_text">{{ item.phone }}</div>
          </template>

          <template v-slot:[`item.callname`]="{ item }">
            <div>
              <div class="auto" v-if="item.currentType == 'auto'">авто</div>

              <span>{{ item.name }}</span>

              <button
                v-if="page_type === 'calls'"
                class="copy-call-id"
                type="button"
                title="Скопировать ID обзвона"
                @click.stop="copy(item.guid.replace('call_', ''))"
              >
                <v-icon size="16">mdi-content-copy</v-icon>
              </button>
            </div>
          </template>
          <template
            v-slot:[`item.data-table-select`]="{ item, isSelected, select }"
          >
            <v-simple-checkbox
              v-if="!(isCarouselHierarchy && item.rowType === 'segment')"
              :value="isSelected"
              color="#4B5EFF"
              :ripple="false"
              @input="select($event)"
            />
          </template>
          <template v-slot:[`item.carousel`]="{ item }">
            <div
              v-if="isCarouselHierarchy"
              class="carousel-cell"
              :class="{
                'carousel-cell--segment': item.rowType === 'segment',
              }"
            >
              <button
                v-if="
                  item.rowType === 'parent' && item.carouselType === 'operator'
                "
                type="button"
                class="carousel-toggle"
                @click.stop="$emit('toggle-carousel', item)"
              >
                <v-icon small>
                  {{ item.expanded ? 'mdi-chevron-down' : 'mdi-chevron-right' }}
                </v-icon>
              </button>

              <span
                v-else-if="item.rowType === 'parent'"
                class="carousel-toggle-placeholder"
              />

              <span
                v-if="item.rowType === 'segment'"
                class="carousel-segment-arrow"
              >
                ↳
              </span>

              <div>
                <strong v-if="item.rowType === 'parent'">
                  {{ item.carousel }}
                </strong>

                <span v-else>
                  {{ item.carousel }}
                </span>

                <div
                  v-if="
                    item.rowType === 'parent' &&
                    item.carouselType === 'operator'
                  "
                  class="carousel-segment-count"
                >
                  {{ item.segments.length }} сегментов
                </div>
              </div>
            </div>

            <span v-else>
              {{ item.carousel || '—' }}
            </span>
          </template>
          <template v-slot:[`item.carouselStatus`]="{ item }">
            <div v-if="isCarouselHierarchy" class="carousel-status-cell">
              <span
                v-if="
                  item.rowType === 'parent' && item.carouselStatus === 'Активна'
                "
                class="carousel-status carousel-status--active"
              >
                Активна
              </span>

              <span
                v-else-if="
                  item.rowType === 'parent' &&
                  item.carouselStatus === 'Только входящие'
                "
                class="carousel-status carousel-status--incoming"
              >
                Только входящие
              </span>

              <span
                v-else-if="item.rowType === 'parent' && item.carouselStatus === 'Неактивна'"
                class="carousel-status carousel-status--inactive"
              >
                Неактивна
              </span>

              <span v-else-if="item.rowType === 'parent'">
                {{ item.carouselStatus || '—' }}
              </span>

              <span
                v-else-if="item.carouselStatus === 'Срок истёк' || item.carouselStatus === 'Нет номера'"
                class="carousel-status carousel-status--inactive"
              >
                {{ item.carouselStatus }}
              </span>
              <span v-else>—</span>
            </div>

            <span v-else>{{ item.carouselStatus || '—' }}</span>
          </template>
          <template v-slot:[`item.answerRate`]="{ item }">
            <span v-if="isCarouselHierarchy">
              {{ String(Number(item.answerRate || 0)).replace('.', ',') }}%
            </span>

            <span v-else>{{ item.answerRate ?? '—' }}</span>
          </template>
          <template v-slot:[`item.autoReplaceRule`]="{ item }">
            <div class="carousel-auto-rule">
              {{ item.autoReplaceRule || '—' }}

              <div
                v-if="
                  item.rowType === 'parent' &&
                  item.carouselType === 'operator' &&
                  item.autoReplaceSummary
                "
                class="carousel-segment-count"
              >
                {{ item.autoReplaceSummary }}
              </div>
            </div>
          </template>
          <template v-slot:[`item.actions`]="{ item }">
            <v-menu v-if="safeItems(item).length > 1" bottom>
              <template v-slot:activator="{ on, attrs }">
                <div class="props" v-bind="attrs" v-on="on">
                  <Icon name="props" />
                </div>
              </template>

              <v-list>
                <div
                  v-for="(menu_item, index) in safeItems(item)"
                  :key="index"
                  @click="$emit(menu_item.action, item)"
                >
                  <v-list-item
                    v-if="item.status == 'stop' || menu_item.action != 'play'"
                  >
                    <v-list-item-title :class="itemClass(menu_item.title)">
                      {{ itemText(menu_item, item) }}
                    </v-list-item-title>
                  </v-list-item>
                </div>
              </v-list>
            </v-menu>
            <div
              v-else-if="safeItems(item).length === 1"
              :class="itemClass(safeItems(item)[0].title)"
              @click="$emit(safeItems(item)[0].action, item)"
            >
              {{ safeItems(item)[0].title }}
            </div>
            <div v-else></div>
          </template>
        </v-data-table>
        <v-pagination
          color="#4B5EFF"
          class="my-4"
          :total-visible="7"
          v-model="page"
          :length="pageCount"
        ></v-pagination>
      </div>
      <div v-if="server">
        <v-checkbox
          v-if="page_type === 'base_phones' || page_type === 'base_black'"
          class="new"
          v-model="selectAll"
          @change="selectAllItems"
          label="Выбрать все"
          color="#4B5EFF"
        ></v-checkbox>
        <v-data-table
          v-model="selected"
          @input="enterSelect()"
          :loading="loading"
          :server-items-length="Number(pageCount_server)"
          :page.sync="server_page"
          :options.sync="options"
          checkbox-color="#4B5EFF"
          :show-select="!hideselect"
          locale="ru-RU"
          no-data-text="Нет данных"
          :headers="displayHeaders"
          :itemsPerPage="perPage"
          :items="displayData"
          hide-default-footer
          :item-key="
            page_type === 'base_phones' || page_type === 'base_black'
              ? 'guid'
              : 'id'
          "
          class="elevation-1"
          loading-text="Загружаем данные таблицы"
        >
          <template v-slot:progress>
            <v-progress-linear indeterminate color="#4B5EFF" absolute top />
          </template>
          <template v-slot:[`item.actions`]="{ item }">
            <v-menu v-if="safeItems(item).length > 1" bottom>
              <template v-slot:activator="{ on, attrs }">
                <div class="props" v-bind="attrs" v-on="on">
                  <Icon name="props" />
                </div>
              </template>

              <v-list>
                <div
                  v-for="(menu_item, index) in safeItems(item)"
                  :key="index"
                  @click="$emit(menu_item.action, item)"
                >
                  <v-list-item
                    v-if="item.status == 'stop' || menu_item.action != 'play'"
                  >
                    <v-list-item-title :class="itemClass(menu_item.title)">
                      {{ itemText(menu_item, item) }}
                    </v-list-item-title>
                  </v-list-item>
                </div>
              </v-list>
            </v-menu>
            <div
              v-else-if="safeItems(item).length === 1"
              :class="itemClass(safeItems(item)[0].title)"
              @click="$emit(safeItems(item)[0].action, item)"
            >
              {{ safeItems(item)[0].title }}
            </div>
            <div v-else></div>
          </template>
          <template v-slot:[`item.n`]="{ item }">
            <v-tooltip top @click="copy(item.id)">
              <template v-slot:activator="{ on, attrs }">
                <div class="table_text" v-bind="attrs" v-on="on">
                  {{ item.n }}
                </div>
              </template>
              <span>{{ item.id }}</span>
            </v-tooltip>
          </template>
          <template v-slot:[`item.created_at`]="{ item }">
            <p>{{ getDateFormat(item.created_at) }}</p>
          </template>
          <template v-slot:[`item.status`]="{ item }">
            <div class="status_wait" v-if="item.status == 'wait'">
              в процессе
            </div>
            <div class="status_end" v-if="item.status == '1'">завершен</div>
            <div class="status_stop" v-if="item.status == 'stop'">
              остановлен
            </div>
            <div class="status_uncall" v-if="item.status == '2'">недозвон</div>
            <div class="status_success" v-if="item.status == 'success'">
              Успешно
            </div>
            <div class="status_stop" v-if="item.status == '4'">
              Не доставлено
            </div>
            <div class="status_success" v-if="item.status == '10'">
              Доставлено
            </div>
          </template>

          <template v-slot:[`item.operator`]="{ item }">
            <div class="operator_ico" v-if="item.operator == 'МТС'">
              <Icon name="op_mts" />
              МТС
            </div>
            <div class="operator_ico" v-else-if="item.operator == 'Билайн'">
              <Icon name="op_beeline" />
              Билайн
            </div>
            <div class="operator_ico" v-else-if="item.operator == 'Мегафон'">
              <Icon name="op_megafon" />
              Мегафон
            </div>
            <div class="operator_ico" v-else-if="item.operator == 'Tele2'">
              <Icon name="op_tele" />
              Tele2
            </div>
            <div
              class="operator_ico"
              v-else-if="item.operator == 'Тинькофф Мобайл'"
            >
              <Icon name="op_tinkoff" />
              Тинькофф Мобайл
            </div>
            <div class="operator_ico" v-else-if="item.operator == 'Yota'">
              <Icon name="op_yota" />
              Yota
            </div>
            <div class="operator_ico" v-else-if="item.operator == 'Ростелеком'">
              <Icon name="op_rst" />
              Ростелеком
            </div>
            <div class="operator_ico" v-else>
              <Icon name="op_other" />
              {{ item.operator ? item.operator : 'Не определено' }}
            </div>
          </template>
          <template v-slot:[`item.record`]="{ item }">
            <div v-if="item.status != '-1'" class="record">
              <Player :item="item" :key="item.id || item.guid" />
            </div>
            <div v-else class="record status_uncall">Нет записи</div>
          </template>
          <template v-slot:[`item.text`]="{ item }">
            <div
              class="table_text"
              :class="{ status_uncall: textFormat(item.text) == 'Нет данных' }"
            >
              {{ textFormat(item.text) }}
            </div>
          </template>
          <template v-slot:[`item.phoneB`]="{ item }">
            <div class="table_text">
              {{
                '+' +
                item.phoneB.substr(0, 1) +
                ' (' +
                item.phoneB.substr(1, 3) +
                ') ' +
                item.phoneB.substr(4, 3) +
                '-' +
                item.phoneB.substr(7, 2) +
                '-' +
                item.phoneB.substr(9, 2)
              }}
            </div>
          </template>
          <template v-slot:[`item.phoneA`]="{ item }">
            <div
              class="table_text"
              v-if="item.phoneA && item.phoneA !== '0' && item.phoneA !== 0"
            >
              {{
                '+' +
                item.phoneA.substr(0, 1) +
                ' (' +
                item.phoneA.substr(1, 3) +
                ') ' +
                item.phoneA.substr(4, 3) +
                '-' +
                item.phoneA.substr(7, 2) +
                '-' +
                item.phoneA.substr(9, 2)
              }}
            </div>
            <div v-else class="record status_uncall">Нет данных</div>
          </template>
          <template v-slot:[`item.phone`]="{ item }">
            <div class="table_text">
              {{
                '+' +
                item.phone.substr(0, 1) +
                ' (' +
                item.phone.substr(1, 3) +
                ') ' +
                item.phone.substr(4, 3) +
                '-' +
                item.phone.substr(7, 2) +
                '-' +
                item.phone.substr(9, 2)
              }}
            </div>
          </template>
        </v-data-table>
        <v-pagination
          color="#4B5EFF"
          class="my-4"
          :total-visible="7"
          v-model="server_page"
          :length="Math.ceil(pageCount_server / perPage)"
        ></v-pagination>
      </div>
    </div>
    <v-dialog
      v-model="groupByDialog"
      max-width="400"
      content-class="grouping-dialog"
    >
      <v-card class="grouping-card">
        <v-card-title class="grouping-title">
          Группировка по полям
          <v-spacer></v-spacer>
          <v-btn icon small @click="groupByDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text class="grouping-content">
          <v-checkbox
            v-for="field in groupByFields"
            :key="field"
            v-model="selectedGroupFields"
            :label="getFieldLabel(field)"
            :value="field"
            color="#4B5EFF"
            hide-details
            class="grouping-checkbox"
          ></v-checkbox>
        </v-card-text>

        <v-card-actions class="grouping-actions">
          <v-btn text @click="clearGrouping"> Сбросить </v-btn>
          <v-spacer></v-spacer>
          <v-btn
            color="#4B5EFF"
            @click="applyGrouping"
            :disabled="selectedGroupFields.length === 0"
            class="apply-btn"
            dark
          >
            Применить
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
// import ItemProps from '../Table/ItemProps.vue'
// import Checkbox from '../Table/CheckboxItem.vue'
import moment from 'moment-timezone';
import Icon from '../SetIcon.vue';
import Player from '../AudioPlayer.vue';
export default {
  props: [
    'groupByFields',
    'headers',
    'items',
    'itemsFn',
    'hideselect',
    'data',
    'perPage',
    'callback_edit',
    'callback_stop',
    'callback_refresh',
    'callback_view',
    'callback_export',
    'callback_play',
    'callback_delete',
    'server',
    'pageCount_server',
    'loading',
    'callback_draw',
    'page_type',
    'noDataText',
  ],
  components: {
    // ItemProps,
    // Checkbox,
    Icon,
    Player,
  },
  data() {
    return {
      groupByDialog: false,
      selectedGroupFields: [],
      groupedItems: [],
      useGrouped: false,
      selectAllVirtual: false,
      selectAll: false,
      page: 1,
      edit_popup: false,
      options: {},
      server_page: 1,
      pageCount: 2,
      selected: [],
      type: [
        {
          name: 'Стандартный',
          value: 'standart',
          tooltip:
            'Остановится после обзвона всех номера в выбранной базе номеров',
        },
        {
          name: 'Автоматический',
          value: 'auto',
          tooltip: 'Звонок срабатывает при активации выбранного триггера',
        },
      ],
    };
  },
  watch: {
    options: {
      handler() {
        this.serverSort();
      },
      deep: true,
    },
    data() {
      if (!['analytics_calls', 'analytics_incoming'].includes(this.page_type))
        return;

      this.$nextTick(() => {
        const state = this.$store.getters['notification/getFooterState'] || {};

        if (state.page_type !== this.page_type) {
          this.selected = [];
          return;
        }

        const selectedIds = new Set((state.data || []).map((item) => item.id));

        this.selected = (this.data || []).filter((item) =>
          selectedIds.has(item.id),
        );
      });
    },
    groupByFields: {
      immediate: true,
      handler(val) {
        if (
          Array.isArray(val) &&
          val.length &&
          this.selectedGroupFields.length === 0
        ) {
          this.selectedGroupFields = [...val];
        }
      },
    },
  },
  beforeDestroy() {
    let data = {
      hide: true,
      data: [],
      page_type: 'none',
      cb_refresh: false,
      cb_clear: false,
    };
    this.$store.commit('notification/setFooterState', data);
  },

  computed: {
    isCarouselHierarchy() {
      return (
        this.page_type === 'carousels' || this.page_type === 'users_carousels'
      );
    },
    displayHeaders() {
      let baseHeaders = this.headers || [];

      if (
        this.useGrouped &&
        this.selectedGroupFields.length &&
        Array.isArray(this.groupByFields)
      ) {
        baseHeaders = baseHeaders.filter((h) => {
          return (
            !this.groupByFields.includes(h.value) ||
            this.selectedGroupFields.includes(h.value)
          );
        });
      }

      if (!this.groupByFields || this.groupByFields.length === 0) {
        return baseHeaders;
      }

      return [
        ...baseHeaders,
        {
          text: '',
          value: 'group_actions',
          sortable: false,
          width: '50px',
        },
      ];
    },

    displayData() {
      if (!this.useGrouped || this.selectedGroupFields.length === 0) {
        return this.data;
      }
      return this.groupedItems;
    },
  },

  methods: {
    carouselRowClass(item) {
      if (this.page_type === 'all_numbers') {
        return 'all-numbers-table-row';
      }
      if (!this.isCarouselHierarchy) return '';

      if (item.rowType === 'segment') {
        return 'carousel-table-row carousel-table-row--segment';
      }

      if (item.rowType === 'parent' && item.expanded) {
        return 'carousel-table-row carousel-table-row--expanded';
      }

      return 'carousel-table-row';
    },
    clearGrouping() {
      this.selectedGroupFields = [];
      this.useGrouped = false;
      this.groupedItems = [];
      this.groupByDialog = false;
      this.$emit('grouping-changed', {
        fields: [],
        data: [],
      });
    },
    getFieldLabel(field) {
      const labels = {
        account: 'Аккаунт',
        channel: 'Транк',
        operator: 'Оператор B-номера',
      };
      return labels[field] || field;
    },
    applyGrouping() {
      if (!this.selectedGroupFields.length) {
        this.useGrouped = false;
        this.groupedItems = [];
        this.$emit('grouping-changed', {
          fields: [],
          data: [],
        });
        this.groupByDialog = false;
        return;
      }

      const groups = {};

      this.data.forEach((item) => {
        const key = this.selectedGroupFields
          .map((field) => item[field] || '')
          .join('|');

        if (!groups[key]) {
          groups[key] = {
            id: key,
            ...this.selectedGroupFields.reduce((acc, field) => {
              acc[field] = item[field] || '';
              return acc;
            }, {}),
          };

          this.headers.forEach((header) => {
            if (
              header.value !== 'id' &&
              !this.selectedGroupFields.includes(header.value)
            ) {
              const val = item[header.value];
              if (typeof val === 'number' || !isNaN(parseFloat(val))) {
                groups[key][header.value] = 0;
              }
            }
          });
        }

        this.headers.forEach((header) => {
          if (
            header.value !== 'id' &&
            !this.selectedGroupFields.includes(header.value)
          ) {
            const val = item[header.value];
            if (typeof val === 'number' || !isNaN(parseFloat(val))) {
              groups[key][header.value] =
                (groups[key][header.value] || 0) + parseFloat(val);
            }
          }
        });
      });
      Object.values(groups).forEach((g) => {
        // Округляем стоимость минуты
        if (typeof g.minutesPrice === 'number') {
          g.minutesPrice = Number(g.minutesPrice.toFixed(2));
        }

        // Округляем общую стоимость
        if (typeof g.totalPrice === 'number') {
          g.totalPrice = Number(g.totalPrice.toFixed(2));
        }

        // Округляем общую стоимость инициации
        if (typeof g.totalInitPrice === 'number') {
          g.totalInitPrice = Number(g.totalInitPrice.toFixed(2));
        }

        // Пересчитываем среднюю стоимость инициации для группы
        if (typeof g.totalInitPrice === 'number' && g.totalCalls > 0) {
          // Средняя цена инициации — это общая сумма инициации, деленная на количество вызовов
          g.initiationPrice = (g.totalInitPrice / g.totalCalls).toFixed(2);
        } else {
          g.initiationPrice = '0.00'; // Если количество вызовов 0, цена инициации = 0
        }

        // Приводим все цены к нужному формату (округляем до 2 знаков после запятой)
        if (typeof g.initiationPrice === 'number') {
          g.initiationPrice = Number(g.initiationPrice).toFixed(2);
        }
      });
      this.groupedItems = Object.values(groups);
      this.useGrouped = true;
      this.groupByDialog = false;

      this.$emit('grouping-changed', {
        fields: this.selectedGroupFields,
        data: this.groupedItems,
      });
    },
    safeItems(row) {
      try {
        if (typeof this.itemsFn === 'function') {
          const base = Array.isArray(this.items) ? this.items : [];
          const out = this.itemsFn(row, base);
          return Array.isArray(out) ? out : base;
        }
        return Array.isArray(this.items) ? this.items : [];
      } catch {
        return Array.isArray(this.items) ? this.items : [];
      }
    },
    selectAllItems() {
      if (!Array.isArray(this.data) || !this.data.length) {
        this.selected = [];
        this.selectAll = false;
        this.selectAllVirtual = false;
        this.enterSelect();
        return;
      }

      if (this.selectAll) {
        const needIds =
          this.page_type === 'base_phones' || this.page_type === 'base_black';
        this.selected = this.isCarouselHierarchy
          ? this.data.filter((item) => !item.selectDisabled)
          : this.data.slice();
        this.selectAllVirtual = !!needIds;
      } else {
        this.selected = [];
        this.selectAllVirtual = false;
      }
      this.enterSelect();
    },
    handleDelete() {
      const needIds =
        this.page_type === 'base_phones' || this.page_type === 'base_black';
      if (this.selectAllVirtual && needIds) {
        this.$emit('need-ids');
      } else {
        this.$emit('delete', this.selected);
      }
      this.selectAllVirtual = false;
      this.selectAll = false;
      this.selected = [];
      this.enterSelect();
    },
    getDateFormat(date) {
      var tz = Intl.DateTimeFormat().resolvedOptions().timeZone;

      const formatDateList = [
        'DD.MM.YYYY HH:mm:ss',
        'YYYY-MM-DD HH:mm:ss',
        'DD.MM.YYYY',
      ]; // Список возможных форматов дат
      let formatDate; // Переменная для хранения результата получения даты
      let outFormat =
        date && String(date).length === 10
          ? 'DD.MM.YYYY'
          : 'DD.MM.YYYY HH:mm:ss';
      formatDateList.forEach((format) => {
        if (moment.utc(date, format).isValid() && !formatDate)
          formatDate = moment.utc(date, format);
      });
      if (!formatDate) formatDate = moment(date);

      date = formatDate.tz(tz).format(outFormat);
      return date;
    },
    clearSelected() {
      this.selected = [];
    },
    customSort(items, index, isDesc) {
      items.sort((a, b) => {
        const noDataValue = 'нет данных';

        if (a[index] === noDataValue && b[index] !== noDataValue) {
          return 1;
        } else if (a[index] !== noDataValue && b[index] === noDataValue) {
          return -1;
        } else if (a[index] === noDataValue && b[index] === noDataValue) {
          return 0;
        }

        if (index == 'target_price') {
          let priceA = 0;
          let priceB = 0;
          if (a['target_on'] && a.target > 0)
            priceA = (a.target_rate / a.target).toFixed(2);
          if (b['target_on'] && b.target > 0)
            priceB = (b.target_rate / b.target).toFixed(2);

          if (isDesc == 'false') {
            return Number(priceA) < Number(priceB) ? -1 : 1;
          } else {
            return Number(priceB) < Number(priceA) ? -1 : 1;
          }
        }
        if (index == 'nums') {
          if (isDesc == 'false') {
            return Number(a['contacts']) < Number(b['contacts']) ? -1 : 1;
          } else {
            return Number(b['contacts']) < Number(a['contacts']) ? -1 : 1;
          }
        }

        if (index == 'target_limit') {
          if (!a['target_on']) a['limit'] = 0;
          if (!b['target_on']) b['limit'] = 0;
          if (isDesc == 'false') {
            return Number(a['limit']) < Number(b['limit']) ? -1 : 1;
          } else {
            return Number(b['limit']) < Number(a['limit']) ? -1 : 1;
          }
        }
        if (index == 'callname') {
          if (isDesc == 'false') {
            return a['name'] < b['name'] ? -1 : 1;
          } else {
            return b['name'] < a['name'] ? -1 : 1;
          }
        }

        const cmp = String(a[index]).localeCompare(
          String(b[index]),
          undefined,
          { numeric: true, sensitivity: 'base' },
        );
        return isDesc == 'false' ? cmp : -cmp;
      });
      return items;
    },
    textFormat(text) {
      if (!text || text == 'NONE' || text == 'undefined') return 'Нет данных';
      return text;
    },
    async copy(text) {
      await navigator.clipboard.writeText(text);
    },
    calcMin(sec) {
      let seconds = Math.floor(sec % 60);
      let minutes = Math.floor(sec / 60);
      if (minutes.toString().length == 1) minutes = '0' + minutes;
      if (seconds.toString().length == 1) seconds = '0' + seconds;
      return `${minutes}:${seconds}`;
    },
    itemText(menu_item, item) {
      if (menu_item.action != 'stopdelete') {
        return menu_item.title;
      } else {
        if (item.status == 'wait') {
          return 'Остановить';
        } else {
          return 'Удалить';
        }
      }
    },
    itemClass(title) {
      if (
        title == 'Остановить' ||
        title == 'Удалить' ||
        title == 'Удалить/Остановить'
      )
        return 'delete_stop';
    },
    numClass(num) {
      if (num[0] == '+') return 'plus';
      else return 'minus';
    },

    enterSelect() {
      if (['analytics_calls', 'analytics_incoming'].includes(this.page_type)) {
        const state = this.$store.getters['notification/getFooterState'] || {};

        const previous =
          state.page_type === this.page_type && Array.isArray(state.data)
            ? state.data
            : [];

        // Записи, отображённые на текущей странице
        const currentPageIds = new Set(
          (this.data || []).map((item) => item.id),
        );

        // Сохраняем выбор с остальных страниц
        const otherPagesSelected = previous.filter(
          (item) => !currentPageIds.has(item.id),
        );

        // Добавляем актуальный выбор текущей страницы
        const allSelected = [...otherPagesSelected, ...this.selected];

        this.$store.commit('notification/setFooterState', {
          hide: allSelected.length === 0,
          data: allSelected,
          page_type: allSelected.length ? this.page_type : 'none',
          cb_refresh: this.callback_refresh,
          cb_clear: this.clearSelected,
          cb_export: this.callback_export,
        });

        return;
      }
      const selectedForFooter = this.isCarouselHierarchy
        ? this.selected.filter((item) => item.rowType !== 'segment')
        : this.selected;
      if (selectedForFooter.length > 0) {
        let data = {
          hide: false,
          data: selectedForFooter,
          page_type: this.page_type,
          cb_refresh: this.callback_refresh,
          cb_clear: this.clearSelected,
          selectAllVirtual: this.selectAllVirtual,
          cb_delete: this.handleDelete,
          cb_export: this.callback_export,
        };

        this.$store.commit('notification/setFooterState', data);
      } else {
        let data = {
          hide: true,
          data: [],
          page_type: 'none',
          cb_refresh: false,
          cb_clear: false,
          selectAllVirtual: false,
          cb_delete: null,
          cb_export: null,
        };
        // console.log(data);
        this.$store.commit('notification/setFooterState', data);
      }
    },
    serverSort() {
      const { sortBy, sortDesc, page } = this.options;
      this.callback_refresh({
        page: page,
        sortBy: sortBy,
        sortDesc: sortDesc,
      });
    },
    editItem(guid, action, item) {
      if (action == 'draw') {
        this.callback_draw(guid, item);
      }
      if (action == 'analytics') {
        this.$router.push('/analytics');
      }
      if (action == 'play') {
        this.callback_play(guid);
      }
      if (action == 'edit') {
        this.callback_edit(true, { id: guid, item: item });
      }
      if (action == 'view') {
        this.callback_view(guid, item.name);
      }
      if (action == 'deletelead') {
        this.$http.post('/base/deletelead', { id: guid }, (data) => {
          this.callback_refresh();
          return data;
        });
      }
      if (action == 'stopdelete') {
        action = 'delete';
        if (item.status == 'wait') {
          action = 'stop';
        }
      }
      if (action == 'stop') {
        this.callback_stop(guid);
      }
      if (action == 'export') {
        this.callback_export(guid, item.name);
      }
      if (action == 'delete') {
        this.callback_delete(guid);
      }
      if (action == 'user_view') {
        this.callback_view(item.phone);
      }
      if (action == 'pays_success') {
        this.callback_edit(item.phone, item.id_number, 'success');
      }
      if (action == 'pays_canselled') {
        this.callback_edit(item.phone, item.id_number, 'cancelled');
      }
      if (action == 'delete_black') {
        this.callback_edit(item.phone);
      }
    },

    deleteItem(item) {
      this.editedIndex = this.desserts.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialogDelete = true;
    },
  },
  beforeMount() {
    // this.data.forEach(element => {
    //   if(element) console.log(4, element)
    // });
  },
};
</script>
<style>
.grouping-dialog {
  border-radius: 12px;
}

.grouping-card {
  border-radius: 12px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.1);
  min-height: 280px;
  display: flex;
  flex-direction: column;
}

.grouping-title {
  background: #f8f9fa;
  border-bottom: 1px solid #e9ecef;
  font-weight: 600;
  color: #2b2d33;
  padding: 20px 24px;
  font-size: 16px;
  flex-shrink: 0;
}
.grouping-content {
  padding: 32px 24px;
  margin: 20px 0 0 0;
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.grouping-checkbox {
  margin: 1px;
  padding: 1px;
}
.grouping-checkbox .v-input__control {
  min-height: 44px;
}
.grouping-checkbox .v-label {
  font-size: 15px;
  color: #2b2d33;
}
.grouping-actions {
  padding: 20px 24px;
  border-top: 1px solid #e9ecef;
  flex-shrink: 0;
}
.apply-btn {
  background-color: #4b5eff !important;
  color: white !important;
  text-transform: none;
  font-weight: 500;
  border-radius: 6px;
  padding: 0 20px;
  height: 40px;
  min-width: 100px;
}
.apply-btn.v-btn--disabled {
  background-color: #e0e0e0 !important;
  color: #9e9e9e !important;
  opacity: 0.7;
}
.grouping-checkbox:hover {
  background: #f8f9fa;
  border-radius: 6px;
  margin-left: -8px;
  margin-right: -8px;
  padding-left: 8px;
  padding-right: 8px;
}
.ids-overlay {
  position: absolute;
  inset: 0;
  background: rgba(255, 255, 255, 0.6);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  z-index: 5;
}
.my-4 .v-pagination__item--active {
  background-color: #4b5eff !important;
  color: #fff !important;
}
.forIc {
  display: inline-block;
  margin-bottom: 2px;
}

.ic {
  position: relative;
  top: 3px;
  display: inline-block;
}

.record {
  width: 100%;
  text-align: center;
}

.table_text {
  max-width: 300px;
  width: 100%;
}

.operator_ico {
  display: flex;
  align-items: center;
}

.operator_ico > .icon {
  margin-right: 5px;
}

.hidden {
  display: none;
}

.table_text {
  font-style: normal;
  font-weight: 500;
  font-size: 15px;
  line-height: 120%;
  color: #2b2d33;
}

.num {
  font-style: normal;
  font-weight: 600;
  font-size: 15px;
  line-height: 120%;
}

.plus {
  color: #008e7d;
}

.delete_stop {
  color: #ee505a;
}

.delete_stop:hover {
  cursor: pointer;
}

.minus {
  color: #c74952;
}

.time {
  margin-right: 8px;
}

.input_wrap {
  width: 132px;
  height: 32px;
}

.props:hover {
  background: #e6f4fc;
  border-radius: 50%;
  width: 20px;
  height: 20px;
}

.hover_actions:hover {
  cursor: pointer;
}

.props {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
}

.auto {
  display: inline-block;
  background: #ffffff;
  border: 1px solid #4b5eff !important;
  border-radius: 4px;
  padding: 2px 6px;
  margin-right: 6px;
}

.status_wait {
  background: #4b5eff4d;
  padding: 4px 8px;
  display: inline-block;
  border-radius: 4px;
}

.status_stop,
.status_uncall {
  text-align: center;
  background: #f0f0f0;
  padding: 4px 8px;
  display: inline-block;
  border-radius: 4px;
}

.status_end,
.status_success {
  background: #8ad5454d;
  padding: 4px 8px;
  display: inline-block;
  border-radius: 4px;
}

.delete {
  font-size: 15px;
  color: #ee505a;
  cursor: pointer;
}

.v-list div {
  cursor: pointer;
}

.table {
  background: #fff;
  border-radius: 8px;
  padding: 20px 16px 32px 16px;
}

.theme--light.v-data-table
  > .v-data-table__wrapper
  > table
  > tbody
  > tr.carousel-table-row:hover:not(.v-data-table__expanded__content):not(
    .v-data-table__empty-wrapper
  ) {
  background: #fafaff !important;
}

.v-application .elevation-1 {
  box-shadow: none !important;
}

.target_container {
  display: flex;
  align-items: flex-start;
  justify-content: left;
}

.target_des {
  display: inline-block;
}

.target {
  width: 15px;
  cursor: pointer;
  margin-left: 5px;
}
.new input[type='checkbox'].v-input--selection-control {
  border-color: #4b5eff; /* Цвет рамки чекбокса */
}

.new
  input[type='checkbox'].v-input--selection-control:checked:not(:disabled)
  ~ .v-input--selection-placeholder::before {
  border-color: #4b5eff;
  background-color: #4b5eff;
}

.new {
  margin-left: 16px;
}
.carousel-cell {
  display: flex;
  align-items: center;
  min-height: 40px;
}

.carousel-cell--segment {
  padding-left: 28px;
}

.carousel-toggle,
.carousel-toggle-placeholder {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  min-width: 28px;
  height: 28px;
  border: 0;
  background: transparent;
}

.carousel-toggle {
  cursor: pointer;
}

.carousel-segment-arrow {
  width: 24px;
  min-width: 24px;
  color: #8b93a7;
}

.carousel-segment-count {
  margin-top: 2px;
  color: #8b93a7;
  font-size: 11px;
  font-weight: 400;
}
.carousel-auto-rule {
  font-size: 13px;
  font-weight: 400;
  line-height: 1.4;
  white-space: nowrap;
}

.carousel-auto-rule .carousel-segment-count {
  font-size: 11px;
  font-weight: 400;
}

.number-status {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  white-space: nowrap;
  font-size: 14px;
  font-weight: 400;
}

.number-status__dot {
  width: 8px;
  min-width: 8px;
  height: 8px;
  border-radius: 50%;
}

.number-status__dot--active {
  background: #55b878;
}

.number-status__dot--incoming {
  background: #aeb4c0;
}
.theme--light.v-data-table
  > .v-data-table__wrapper
  > table
  > tbody
  > tr.carousel-table-row--expanded,
.theme--light.v-data-table
  > .v-data-table__wrapper
  > table
  > tbody
  > tr.carousel-table-row--segment {
  background: #f8f9ff;
}

.theme--light.v-data-table
  > .v-data-table__wrapper
  > table
  > tbody
  > tr.carousel-table-row
  > td {
  height: 63px;
  border-bottom: 1px solid #e5e8f3 !important;
}

.theme--light.v-data-table
  > .v-data-table__wrapper
  > table
  > tbody
  > tr.carousel-table-row--segment
  > td:first-child {
  border-left: 2px solid #d9dfff;
}

.carousel-cell--segment > div > span {
  font-weight: 600;
}
.theme--light.v-data-table
  > .v-data-table__wrapper
  > table
  > tbody
  > tr.carousel-table-row:hover {
  background: #f5f6fc !important;
}
.carousel-status {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 24px;
  padding: 0 10px;
  border-radius: 12px;
  font-size: 12px;
  line-height: 24px;
  white-space: nowrap;
  box-sizing: border-box;
}
.carousel-status-cell {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
}
.carousel-status--active {
  color: #278b49;
  background: #e8f7ec;
}
.carousel-status--inactive {
  color: #c62828;
  background: #fdebec;
}
.carousel-status--incoming {
  color: #68707f;
  background: #eef0f4;
  transform: translateX(-21px);
}
.all-numbers-phone {
  color: #24324a;
  font-size: 14px;
  font-weight: 600;
  white-space: nowrap;
}
.theme--light.v-data-table
  > .v-data-table__wrapper
  > table
  > tbody
  > tr.all-numbers-table-row
  > td {
  height: 47px;
  border-bottom: 1px solid #e8eaf0 !important;
}

.theme--light.v-data-table
  > .v-data-table__wrapper
  > table
  > tbody
  > tr.all-numbers-table-row:hover:not(.v-data-table__expanded__content):not(
    .v-data-table__empty-wrapper
  ) {
  background: #fafaff !important;
}

.carousel-fixed-table > .v-data-table__wrapper > table {
  width: 100%;
  table-layout: fixed;
}

.carousel-fixed-table > .v-data-table__wrapper {
  overflow-x: hidden;
}

.carousel-fixed-table > .v-data-table__wrapper > table > thead > tr > th,
.carousel-fixed-table > .v-data-table__wrapper > table > tbody > tr > td {
  box-sizing: border-box;
  vertical-align: middle;
}

.carousel-fixed-table > .v-data-table__wrapper > table > thead > tr > th {
  white-space: normal;
  line-height: 1.3;
}

.carousel-fixed-table
  > .v-data-table__wrapper
  > table
  > thead
  > tr
  > th:first-child,
.carousel-fixed-table
  > .v-data-table__wrapper
  > table
  > tbody
  > tr
  > td:first-child {
  width: 48px;
}

.carousel-fixed-table
  > .v-data-table__wrapper
  > table
  > thead
  > tr
  > th:nth-child(2),
.carousel-fixed-table
  > .v-data-table__wrapper
  > table
  > tbody
  > tr
  > td:nth-child(2) {
  width: 260px;
}

.carousel-fixed-table
  > .v-data-table__wrapper
  > table
  > thead
  > tr
  > th:nth-child(4),
.carousel-fixed-table
  > .v-data-table__wrapper
  > table
  > tbody
  > tr
  > td:nth-child(4) {
  width: 135px;
}

.carousel-fixed-table
  > .v-data-table__wrapper
  > table
  > thead
  > tr
  > th:last-child,
.carousel-fixed-table
  > .v-data-table__wrapper
  > table
  > tbody
  > tr
  > td:last-child {
  width: 105px;
  padding-left: 8px !important;
  padding-right: 8px !important;
  text-align: center !important;
}

.carousel-fixed-table .carousel-status-cell > span {
  white-space: nowrap;
}
.copy-call-id {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  margin-left: 8px;
  padding: 2px 6px;
  color: #4b5eff;
  font-size: 12px;
  white-space: nowrap;
  cursor: pointer;
}

.copy-call-id:hover {
  background: #f0f1ff;
  border-radius: 4px;
}
@media (max-width: 1024px) {
  .table {
    padding: 12px 8px 20px;
  }

  .numbers-mobile-table > .v-data-table__wrapper {
    overflow-x: hidden;
  }

  .numbers-mobile-table > .v-data-table__wrapper > table {
    width: 100%;
    table-layout: auto;
  }

  .numbers-mobile-table > .v-data-table__wrapper > table > thead > tr > th,
  .numbers-mobile-table > .v-data-table__wrapper > table > tbody > tr > td {
    width: 100% !important;
    max-width: none !important;
  }

  .numbers-mobile-table .v-data-table__mobile-row {
    display: grid !important;
    grid-template-columns: minmax(112px, 42%) minmax(0, 1fr);
    align-items: center;
    gap: 12px;
    width: 100%;
    min-height: 44px;
    height: auto !important;
    padding: 10px 12px !important;
  }

  .numbers-mobile-table .v-data-table__mobile-row__header {
    color: #6f7075;
    font-size: 12px;
    line-height: 1.3;
    white-space: normal;
  }

  .numbers-mobile-table .v-data-table__mobile-row__cell {
    min-width: 0;
    text-align: right;
    overflow-wrap: anywhere;
  }

  .numbers-mobile-table .v-data-table__mobile-row__cell .carousel-cell {
    justify-content: flex-end;
  }

  .numbers-mobile-table .carousel-cell--segment {
    padding-left: 0;
  }

  .numbers-mobile-table .carousel-status-cell {
    justify-content: flex-end;
  }

  .numbers-mobile-table .carousel-status--incoming {
    transform: none;
  }
}
@media (min-width: 1025px) and (max-width: 1440px) {
  .table {
    padding: 14px 10px 24px;
  }

  .carousel-fixed-table > .v-data-table__wrapper > table > thead > tr > th,
  .carousel-fixed-table > .v-data-table__wrapper > table > tbody > tr > td {
    padding-left: 8px !important;
    padding-right: 8px !important;
    font-size: 12px;
  }

  .carousel-fixed-table > .v-data-table__wrapper > table > thead > tr > th {
    font-size: 11px;
    line-height: 1.25;
  }

  .carousel-fixed-table
    > .v-data-table__wrapper
    > table
    > tbody
    > tr.carousel-table-row
    > td {
    height: 56px;
  }

  .carousel-fixed-table
    > .v-data-table__wrapper
    > table
    > thead
    > tr
    > th:first-child,
  .carousel-fixed-table
    > .v-data-table__wrapper
    > table
    > tbody
    > tr
    > td:first-child {
    width: 40px;
  }

  .carousel-fixed-table
    > .v-data-table__wrapper
    > table
    > thead
    > tr
    > th:nth-child(2),
  .carousel-fixed-table
    > .v-data-table__wrapper
    > table
    > tbody
    > tr
    > td:nth-child(2) {
    width: 210px;
  }

  .carousel-fixed-table
    > .v-data-table__wrapper
    > table
    > thead
    > tr
    > th:nth-child(4),
  .carousel-fixed-table
    > .v-data-table__wrapper
    > table
    > tbody
    > tr
    > td:nth-child(4) {
    width: 118px;
  }

  .carousel-fixed-table
    > .v-data-table__wrapper
    > table
    > thead
    > tr
    > th:last-child,
  .carousel-fixed-table
    > .v-data-table__wrapper
    > table
    > tbody
    > tr
    > td:last-child {
    width: 64px;
  }

  .carousel-status {
    height: 22px;
    padding: 0 8px;
    font-size: 11px;
    line-height: 22px;
  }
  .all-numbers-compact-table > .v-data-table__wrapper {
    overflow-x: hidden;
  }

  .all-numbers-compact-table > .v-data-table__wrapper > table {
    width: 100%;
    table-layout: fixed;
  }

  .all-numbers-compact-table > .v-data-table__wrapper > table > thead > tr > th,
  .all-numbers-compact-table
    > .v-data-table__wrapper
    > table
    > tbody
    > tr
    > td {
    box-sizing: border-box;
    padding-left: 7px !important;
    padding-right: 7px !important;
    vertical-align: middle;
    font-size: 12px;
  }

  .all-numbers-compact-table
    > .v-data-table__wrapper
    > table
    > thead
    > tr
    > th {
    white-space: normal;
    font-size: 11px;
    line-height: 1.25;
  }

  .all-numbers-compact-table
    > .v-data-table__wrapper
    > table
    > thead
    > tr
    > th:first-child,
  .all-numbers-compact-table
    > .v-data-table__wrapper
    > table
    > tbody
    > tr
    > td:first-child {
    width: 140px;
  }

  .all-numbers-compact-table
    > .v-data-table__wrapper
    > table
    > thead
    > tr
    > th:nth-child(2),
  .all-numbers-compact-table
    > .v-data-table__wrapper
    > table
    > tbody
    > tr
    > td:nth-child(2) {
    width: 125px;
  }

  .all-numbers-compact-table
    > .v-data-table__wrapper
    > table
    > thead
    > tr
    > th:nth-child(5),
  .all-numbers-compact-table
    > .v-data-table__wrapper
    > table
    > tbody
    > tr
    > td:nth-child(5) {
    width: 145px;
  }

  .all-numbers-compact-table
    > .v-data-table__wrapper
    > table
    > thead
    > tr
    > th:nth-child(6),
  .all-numbers-compact-table
    > .v-data-table__wrapper
    > table
    > tbody
    > tr
    > td:nth-child(6) {
    width: 80px;
  }
}
</style>
